module.exports = __webpack_public_path__ + "img/bg.770135a1.jpg";